import { createFileRoute } from "@tanstack/react-router";
import EstmanPage from "@/features/public/pages/estman";

export const Route = createFileRoute("/(public)/_public/products/estman")({
  component: EstmanPage,
});
